import { api } from "../../../utils/api";

// 🔹 Get all purchase orders
export const getPurchaseOrders = () => {
  return api.get("/purchase-orders");
};

// 🔹 Create purchase order
export const createPurchaseOrder = (data) => {
  return api.post("/purchase-orders", data);
};

export const getPurchaseOrderById = async (id) => {
  const res = await api.get(`/purchase-orders/${id}`);
  return res.data; // return clean PO object
};

export const fetchBoqItems = async (purchaseOrderId) => {
  const res = await api.get(`/purchase-orders/boq-items/${purchaseOrderId}`);
  return res.data; // return list of BOQ items
};

// 🔹 Update purchase order
export const updatePurchaseOrder = async (id, data) => {
  const res = await api.post(`/purchase-orders/${id}/update`, data);
  return res.data;
};
// 🔹 (future ready)
// export const updatePurchaseOrder = (id, data) =>
//   api.put(`/purchase-orders/${id}`, data);
//
// export const deletePurchaseOrder = (id) =>
//   api.delete(`/purchase-orders/${id}`);

// for payemtn for vendor
// CREATE PAYMENT
export const createVendorPayment = async (data) => {
  const res = await api.post("/purchase-orders/vendor-payments", data);
  return res.data;
};

// UPLOAD FILE
export const uploadVendorPaymentFile = async (id, file) => {
  const formData = new FormData();
  formData.append("attachment", file);

  const res = await api.post(
    `/purchase-orders/vendor-payments/${id}/upload`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
  );

  return res.data;
};

// GET HISTORY
export const getVendorPaymentHistory = async (poId) => {
  const res = await api.get(`/purchase-orders/vendor-payments/history/${poId}`);
  return res.data;
};

// DOWNLOAD FILE
export const downloadVendorPaymentFile = async (id) => {
  const res = await api.get(`/purchase-orders/vendor-payments/download/${id}`, {
    responseType: "blob",
  });

  return res.data;
};
